import axios from '../../axios-dashboard'

import * as actionTypes from './actionTypes'

export const fetchSchedulersStart = () => {
    return {
        type: actionTypes.SCHEDULERS_FETCH_START
    }
};

export const fetchSchedulersSuccess = (schedulers) => {
    return {
        type: actionTypes.SCHEDULERS_FETCH_SUCCESS,
        schedulers: schedulers || [],
    }
};

export const fetchSchedulersFail = (error) => {
    return {
        type: actionTypes.SCHEDULERS_FETCH_FAIL,
        error: error,
    }
};

export const fetchSchedulers = (token) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(fetchSchedulersStart());
        let url = "/scheduler";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'getSchedulers'
        }).then(response => {
            dispatch(fetchSchedulersSuccess(response.data))
        }).catch(err => {
            dispatch(fetchSchedulersFail(err.response.data.error))
        })
    }
};

export const copySchedulerStart = () => {
    return {
        type: actionTypes.COPY_SCHEDULER_START
    }
};

export const copySchedulerSuccess = (schedulers) => {
    return {
        type: actionTypes.COPY_SCHEDULER_SUCCESS,
        schedulers: schedulers,
    }
};

export const copySchedulerFail = (error) => {
    return {
        type: actionTypes.COPY_SCHEDULER_FAIL,
        error: error,
    }
};

export const copyScheduler = (token, name) => {
  return dispatch => {
      if (!token || !name) {
          return
      }
      dispatch(copySchedulerStart())
      let url = "/scheduler";
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      axios.post(url, {
          action: 'copyScheduler',
          schedulers: [{name: name}],
      }).then(response => {
          dispatch(copySchedulerSuccess(response.data))
      }).catch(err => {
          dispatch(copySchedulerFail(err.response.data.error))
      })
  }
};

export const editSchedulerStart = () => {
    return {
        type: actionTypes.EDIT_SCHEDULER_START
    }
};

export const editSchedulerSuccess = (schedulers) => {
    return {
        type: actionTypes.EDIT_SCHEDULER_SUCCESS,
        schedulers: schedulers,
    }
};

export const editSchedulerFail = (error) => {
    return {
        type: actionTypes.EDIT_SCHEDULER_FAIL,
        error: error,
    }
};

export const editSchedulers = (token, schedulers) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(editSchedulerStart())
        let url = "/scheduler";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'updateSchedulers',
            schedulers: schedulers,
        }).then(response => {
            dispatch(editSchedulerSuccess(response.data))
        }).catch(err => {
            dispatch(editSchedulerFail(err.response.data.error))
        })
    }
};